import { gql } from 'apollo-angular';

const GET_PRODUCTS_BY_RFP = gql`
  query GetProductsByRfp(
    $rfpId: Long
    $includeFormularyPrice: Boolean = false
  ) {
    optimizedRfp(id: $rfpId) {
      products {
        id
        catalogNumber
        description
        packageString
        status
        brandName
        aptitudeCategory {
          id
          name
        }
        categories {
          id
          name
          parents {
            id
            name
          }
        }
        productSource
        scopeStatus
        seller {
          id
          name
        }
        sysSeller {
          id
          name
        }
        formularyPrice @include(if: $includeFormularyPrice)
        formularyPriceState @include(if: $includeFormularyPrice)
        subCategoryFormularyPrice @include(if: $includeFormularyPrice)
        spend {
          actualSpend
          continuedSpend
          annualizedSpend
          lastPricePaid
        }
        manufacturer {
          id
          name
        }
        distributor {
          id
          name
        }
        baseProductId
        supplierType
        distributor {
          id
          name
        }
        parentManufacturer {
          id
          name
        }
        parentDistributor {
          id
          name
        }
      }
    }
  }
`;

export default GET_PRODUCTS_BY_RFP;
